module.exports = __webpack_public_path__ + "assets/img/bgy.db4106f2.jpg";